import type { SVGProps } from 'react';
const SvgTackle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" {...props}>
    <path
      fillRule="evenodd"
      d="M25.227 13.068h5.018c.701.01 1.263.585 1.255 1.288v1.898a1.273 1.273 0 0 1-1.256 1.288h-.008v10.062c0 .658-.505 1.193-1.126 1.193H9.889c-.621 0-1.126-.535-1.126-1.193V17.542h-.008A1.273 1.273 0 0 1 7.5 16.254v-1.898a1.273 1.273 0 0 1 1.254-1.288h5.018v-2.95c0-.617.5-1.118 1.117-1.118h9.222a1.12 1.12 0 0 1 1.116 1.118zm-8.599 0h5.746V11.44h-5.746z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTackle;
